module.exports = __webpack_public_path__ + "img/组 103.f7adfdb1.png";